import { render, staticRenderFns } from "./Projectbatch.vue?vue&type=template&id=38d60fa8&scoped=true&"
import script from "./Projectbatch.vue?vue&type=script&lang=js&"
export * from "./Projectbatch.vue?vue&type=script&lang=js&"
import style0 from "./Projectbatch.vue?vue&type=style&index=0&id=38d60fa8&scoped=true&lang=css&"
import style1 from "./Projectbatch.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d60fa8",
  null
  
)

export default component.exports